( function( $ ) {

var pageId = 'page-events',
    page = '#' + pageId;

$(document).on('pjaxload#' + pageId, function(e, $page, page) {
    $('#nav-events').addClass('active');

    tower.scrollLoad($page, function( loadBtn ) {
        var lastEventId = $('.event:last').attr('id');

        if (lastEventId) {
            lastEventId = lastEventId.replace('event-', '');
        } else {
            return;
        }

        return $.ajax({
            url: location.href,
            method: 'GET',
            dataType: "html",
            data: {
                till_id: lastEventId
            },
            success: function(result) {
                var $eventEls;
                try {
                    $eventEls = $('<div/>').append($.trim(result)).children();
                } catch (e) {
                    $eventEls = '';
                }

                if (result && result.length > 0) {
                    $('.init-events, .init-events-filter').remove();

                    tower.initEventList($eventEls);
                    tower.adjustEventsDate($eventEls);
                    tower.adjustReadableDate($eventEls);
                    tower.adjustCreatedAtTime($eventEls);
                }
            }
        });
    });

    tower.initEventList();
    tower.adjustReadableDate();
    tower.adjustEventsDate();
    tower.adjustCreatedAtTime();

    initProjectSelect($page);
    initMemberSelect($page);
    initCollapsedEventsCount($page);
});

var initProjectSelect = function($page) {
    var projectSelect = simple.select({
        el: $page.find('#project-filter-select'),
        onItemRender: function($itemEl, item) {
            if (item._value == -1) {
                $itemEl.addClass('all-item')
            }
            return $itemEl;
        }
    });

    projectSelect.on('select', function(e, item) {
        var url = simple.url();
        url.search.by_project = item._value;

        tower.stack.load(url.toString('relative'), {
            root: true,
            nocache: true
        });
    });
}

var initMemberSelect = function($page) {
    var memberSelect = simple.select({
        el: $page.find('#member-filter-select'),
        cls: 'member-filter',
        onItemRender: function($itemEl, item) {
            if (item._value == -1) {
                $itemEl.addClass('all-item')
            } else {
                $itemEl.addClass('member-item')
                var $span = $('.label',$itemEl);
                $img = $('<img>').attr('src',item.gavatar).addClass('avatar').insertBefore($span);
                $span.addClass('member-item')
            }
            return $itemEl;
        }
    });

    memberSelect.on('select', function(e, item) {
        var url = simple.url();
        url.search.by_member = item._value;

        tower.stack.load(url.toString('relative'), {
            root: true,
            nocache: true
        });
    });
}

var initCollapsedEventsCount = function($page) {
    $page.on('click', '.collapsed-events-count .content', function(e) {
        var $count = $(e.target).closest('.collapsed-events-count');
        $count.prevUntil('.event-comment:not(.collapsed)').removeClass('collapsed');
        $count.remove();
    });
};

var commentEventCollapsible = function($el, $prevEl) {
    if (!$prevEl) return false

    var isSameCommentable =
        $prevEl.data('commentable-guid') === $el.data('commentable-guid');
    var isSameAncestor =
        $prevEl.data('ancestor-guid') === $el.data('ancestor-guid');
    return isSameCommentable && isSameAncestor;
}

var insertCollapsedEventsCount = function($event) {
    var $collapsedEls =
        $event.removeClass('collapsed').prevUntil('.event-comment:not(.collapsed)')

    if ($collapsedEls.length > 1) {
        $($('#tpl-collapsed-events-count').html())
            .insertBefore($event)
            .find('.content .count').text($collapsedEls.length);
    } else {
        $collapsedEls.removeClass('collapsed');
    }
}

var collapseCommentEvents = function($ancestor) {
    var $events = $ancestor.find('.event');
    var $lastCommentEvent;

    $ancestor.find('.collapsed-events-count').remove()

    $events.each(function(index, event) {
        var $event = $(event);

        if (!$event.is('.event-comment')) {
            if ($lastCommentEvent && $lastCommentEvent.is('.collapsed')) {
                insertCollapsedEventsCount($lastCommentEvent);
            }
            $lastCommentEvent = null;
        } else {
            if (commentEventCollapsible($event, $lastCommentEvent)) {
                $event.addClass('collapsed');
            } else if ($lastCommentEvent && $lastCommentEvent.is('.collapsed')) {
                insertCollapsedEventsCount($lastCommentEvent);
            }

            $lastCommentEvent = $event;
        }
    });

    if ($lastCommentEvent && $lastCommentEvent.is('.collapsed')) {
        insertCollapsedEventsCount($lastCommentEvent);
    }
}

$.extend(tower, {
    initEventList: function($eventEls, prepend) {
        var $page = $('.workspace .page-inner:last');
        if (!$page.is('#page-events')) {
            return;
        }

        var $list = $page.find('.team-events');
        if (!$eventEls && !$list.hasClass('loading')) {
            return;
        }

        var today = tower.now().startOf('day');
        var $day;
        var $ancestor;
        var $ancestors = [];

        if (prepend) {
            $day = $list.find('.events-day:first');
            $ancestor = $day.find('.events-ancestor:first');
        } else {
            $day = $list.find('.events-day:last');
            $ancestor = $day.find('.events-ancestor:last');
        }

        $eventEls = $eventEls || $list.children('.event');
        $eventEls.each(function(i, eventEl) {
            var $eventEl = $(eventEl);
            var dateStr = $eventEl.find('.event-created-at').data('created-at');
            var date = moment.tz(dateStr, tower.me.tz).startOf('day');

            if (!$day || $day.length === 0 || $day.data('absdate') !== date.format()) {
                $day = $(simple.tpl($('#tpl-events-day').html(), {
                    date: date.format()
                }));

                if (prepend) {
                    $day.prependTo($list);
                } else {
                    $day.appendTo($list);
                }

                if (date.isSame(today, 'day')) {
                    $day.find('.events-day-title').empty().text('今');
                } else if (date.isSame(today.clone().subtract(1, 'd'), 'day')) {
                    $day.find('.events-day-title').empty().text('昨');
                } else {
                    $day.find('.events-day-title')
                        .find('.date').text(date.format('M/D'))
                        .end()
                        .find('.day').text(moment.weekdaysShort(date.day()));
                }

                if (date.day() % 6 === 0) {
                    $day.addClass('weekend');
                }

                $ancestor = null;
            }

            var ancestor = {
                guid: $eventEl.data('ancestor-guid'),
                name: $eventEl.data('ancestor-name'),
                url: $eventEl.data('ancestor-url')
            };
            if (!$ancestor || $ancestor.length === 0 || $ancestor.data('ancestor-guid') !== ancestor.guid) {
                $ancestor = $(simple.tpl($('#tpl-events-ancestor').html(), {
                    guid: ancestor.guid,
                    name: ancestor.name,
                    url: ancestor.url
                }));

                if (prepend) {
                    $ancestor.prependTo($day.find('.events-day-content'));
                } else {
                    $ancestor.appendTo($day.find('.events-day-content'));
                }
            }

            if (prepend) {
                $eventEl.insertAfter($ancestor.find('.events-ancestor-title'));
            } else {
                $eventEl.appendTo($ancestor);
            }

            if ($ancestors.indexOf($ancestor) === -1) $ancestors.push($ancestor);
        });

        $.each($ancestors, function(index, $ancestor) {
            collapseCommentEvents($ancestor);
        });

        $list.removeClass('loading');
    },

    adjustEventsDate: function(scope) {
        scope = scope || $('body');

        var today = tower.now().startOf('day'),
            yesterday = today.clone().add(-1, 'd'),
            eventEls = scope.find('.events-day').add(scope.filter('.events-day'));

        eventEls.each(function() {
            var el = $(this),
                str = '',
                date = moment.tz(el.data('absdate'), 'YYYY-MM-DD', tower.me.tz);

            if (date.isSame(today)) {
                str = '今';
            } else if (date.isSame(yesterday)) {
                str = '昨';
            } else {
                str = '<span class="date">' + date.format('M/D') + '</span><span class="day">' + moment.weekdaysShort(date.day()) + '</span>';
            }

            el.toggleClass('weekend', date.isoWeekday() > 5)
                .find('.events-day-title').html(str);
        });
    },

    adjustCreatedAtTime: function(scope) {
        scope = scope || $(page);

        scope.find('.event-created-at').each(function() {
            var el = $(this),
                createdAt = moment.tz(el.data('created-at'), tower.me.tz);
            if (createdAt.isValid()) {
                el.text(createdAt.format('HH:mm'));
            }
        });
    }
});

})( jQuery );
